<script>
import Velocity from 'velocity-animate'
import OFadeTransition from './OFadeTransition'
export default {
  extends: OFadeTransition,
  props: {
    right: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    beforeEnter (el) {
      el.style.transformOrigin = (this.right ? 'left ' : 'right ') + 'center'
      Velocity.hook(el, 'scaleX', '0')
    },
    enter (el, done) {
      this.beforeEnter(el)
      Velocity(el,
        {
          scaleX: [1, 0]
        },
        {
          duration: this.duration / this.speed,
          delay: this.delay / this.speed,
          complete: done
        }
      )
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/transitions/OScaleXTransition.vue